import React from 'react';
import ReactPlaceholder from 'react-placeholder';
import { useTranslation } from 'next-i18next';

import BREAKPOINT from 'src/shared/config/Breakpoint';
import useResize from 'src/shared/hooks/useResize';
import MediaCategory from 'src/config/MediaCategory';
import ArticlePostModel from 'src/types/article/ArticlePostModel';
import RoundedButton from 'src/shared/components/RoundedButton';

import EventList from './components/EventList';
import ArticleList from './components/ArticleList';
import FeaturedFromOthersCards from '../FeaturedFromOtherCards';
import styles from './styles.module.scss';

interface Props {
    isFetchingBasic: boolean;
    isFetchingAdditional: boolean;
    hasMorePages: boolean;
    category: string;
    basicArticles: ArticlePostModel[];
    additionalArticles: ArticlePostModel[];
    featuredFromOthers: ArticlePostModel[];
    loadMore: () => void;
}

const ListContent = ({
    isFetchingBasic,
    isFetchingAdditional,
    hasMorePages,
    category,
    basicArticles,
    additionalArticles,
    featuredFromOthers,
    loadMore,
}: Props) => {
    const { t } = useTranslation();
    const { screenSize } = useResize();
    const isEventType = category === MediaCategory.EVENTS;
    const isSideColumnShown = screenSize.width > BREAKPOINT.LG && !!featuredFromOthers.length;

    return (
        <div className={`${styles.container} ${isFetchingBasic ? styles.loading : ''}`}>
            <ReactPlaceholder className={styles.placeholder} showLoadingAnimation type="media" rows={20} ready={!isFetchingBasic}>
                {!basicArticles.length && <div className={styles.emptyListScreen} />}
                {!!basicArticles.length && (
                    <div className={styles.mainColumn}>
                        {isEventType && (
                            <EventList
                                isFetchingAdditional={isFetchingAdditional}
                                basicEvents={basicArticles}
                                additionalEvents={additionalArticles}
                                featuredFromOthers={featuredFromOthers}
                                isSideColumnShown={isSideColumnShown}
                            />
                        )}
                        {!isEventType && (
                            <ArticleList
                                isFetchingAdditional={isFetchingAdditional}
                                basicArticles={basicArticles}
                                additionalArticles={additionalArticles}
                                featuredFromOthers={featuredFromOthers}
                            />
                        )}
                        {hasMorePages && (
                            <div className={styles.more}>
                                <RoundedButton className={styles.showMoreButton} type="tertiary-on-light" onClick={loadMore}>
                                    {t('button_show_more')}
                                </RoundedButton>
                            </div>
                        )}
                    </div>
                )}
                {isSideColumnShown && (
                    <div className={styles.sideColumn}>
                        <FeaturedFromOthersCards items={featuredFromOthers} isColumn />
                    </div>
                )}
            </ReactPlaceholder>
        </div>
    );
};

export default ListContent;
